import angular from 'angular';

let dependenciesModule = angular.module('app.dependencies', [
    'angular-jwt',
    'ui.router',
    'ui.bootstrap',
    'jkAngularRatingStars',
    'ngAria',
    'ngMessages',
    'ngCookies',
    'ngAnimate',
    'ngMaterial',
    'rzModule',
    'vcRecaptcha',
    'uiGmapgoogle-maps',
    'simplePagination',
    'ngTable',
    'naif.base64',
    'MassAutoComplete',
    'angularUtils.directives.dirPagination',
    'ui.grid',
    'ui.grid.selection',
    'ui.grid.resizeColumns',
    'ui.grid.edit',
    'ui.grid.rowEdit',
    'ui.grid.cellNav',
    'ui.grid.pinning',
    'ui.grid.pagination',
    'ui.grid.grouping',
    'ui.grid.autoResize',
    'ui.grid.exporter',
    'oc.lazyLoad',
    'ui.carousel',
    '720kb.socialshare',
    'vAccordion',
    '720kb.datepicker']);

export default dependenciesModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/app.dependencies.js
 **/